import PropTypes from "prop-types"
import React from "react"

import AlertBanner from "src/components/AlertBanner"
import Button from "src/components/Button"

import { isPhoneRefusal } from "../../submitRefusal"

const SubmitFailureNotice = ({
  failure,
  copy,
  onBackToAdditionalInformation,
  onBackToPayment,
}) => {
  const { message, terminal, marinaPhone, code } = failure
  const phoneRefusal = isPhoneRefusal(failure)
  const paymentRefusal = code?.startsWith("payment_method_")

  return (
    <AlertBanner type={terminal ? "error" : "warning"}>
      <div className="flex flex-col gap-1">
        <span>{message}</span>
        {terminal && marinaPhone && (
          <a
            className="font-semibold text-blue-600"
            href={`tel:${marinaPhone}`}
          >
            {copy.callMarina}
          </a>
        )}
        {phoneRefusal && onBackToAdditionalInformation && (
          <div>
            <Button variant="tertiary" onClick={onBackToAdditionalInformation}>
              {copy.backToAdditionalInformation}
            </Button>
          </div>
        )}
        {paymentRefusal && onBackToPayment && (
          <div>
            <Button variant="tertiary" onClick={onBackToPayment}>
              {copy.backToPaymentMethod}
            </Button>
          </div>
        )}
      </div>
    </AlertBanner>
  )
}

SubmitFailureNotice.propTypes = {
  failure: PropTypes.shape({
    code: PropTypes.string,
    message: PropTypes.string.isRequired,
    terminal: PropTypes.bool,
    marinaPhone: PropTypes.string,
    attributes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  copy: PropTypes.shape({
    callMarina: PropTypes.string,
    backToAdditionalInformation: PropTypes.string,
    backToPaymentMethod: PropTypes.string,
  }).isRequired,
  onBackToAdditionalInformation: PropTypes.func,
  onBackToPayment: PropTypes.func,
}

export default SubmitFailureNotice
